export const MonopolioLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={36} height={36} fill="none">
    <g filter="url(#a)">
      <path
        fill="#0368FE"
        d="M6 15c0-4.621 0-6.932 1.04-8.63a7.059 7.059 0 0 1 2.33-2.33C11.069 3 13.38 3 18 3s6.932 0 8.63 1.04a7.058 7.058 0 0 1 2.33 2.33C30 8.069 30 10.38 30 15s0 6.932-1.04 8.63a7.058 7.058 0 0 1-2.33 2.33C24.931 27 22.62 27 18 27s-6.932 0-8.63-1.04a7.058 7.058 0 0 1-2.33-2.33C6 21.931 6 19.62 6 15Z"
      />
      <path
        fill="#fff"
        d="M21.666 11c-1.335 0-2.466.503-3.144 1.316-.587-.89-1.613-1.23-2.836-1.23h-4.763v7.908h1.951v-6.443h2.343c1.191 0 1.949.736 1.949 2.152V19h1.9v-4.018c0-1.568.894-2.373 2.19-2.373 1.195 0 1.893.678 1.893 2.091v4.297h1.901v-4.53c0-2.38-1.356-3.464-3.38-3.464L21.665 11Z"
      />
    </g>
    <defs>
      <filter
        id="a"
        width={36}
        height={36}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={3} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.16 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_11811_20790"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_11811_20790"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
